export default __webpack_public_path__ + "static/media/Asset 1 2.c3fa8f7f.png";